import axios from "axios";

const remoteApi = axios.create({
	baseURL: "https://angelswing-frontend-test-serverless-api.vercel.app/api",
});

remoteApi.interceptors.response.use((response) => response.data);

export default remoteApi;
